namespace RedBullMOBILE360.Web.Modules.Common {
    export enum SubStatus {
        Idle = 1,
        Active = 2,
        Barring = 3,
        Suspended = 4,
        Pre_deactivate = 5,
        Deactive = 9
    }
    Serenity.Decorators.registerEnumType(SubStatus, 'RedBullMOBILE360.Web.Modules.Common.SubStatus');
}
